import { BaseApi as Base } from '@micromag/data';

class MediasApi extends Base {
    find(id) {
        return this.requestGet(
            this.route('medias.show', {
                media: id,
            }),
        );
    }

    get(query = {}, page = 1, count = 10) {
        const finalQuery = {
            ...query,
        };
        if (page !== null) {
            finalQuery.page = page;
        }
        if (count !== null) {
            finalQuery.count = count;
        }
        return this.requestGet(this.route('medias.index'), finalQuery);
    }

    getTrashed(query = {}, page = 1, count = 10) {
        const finalQuery = {
            ...query,
            trashed: 'true'
        };
        return this.get(finalQuery, page, count);
    }

    getTags(query = {}, count = 10) {
        const finalQuery = {
            ...query,
        };
        if (count !== null) {
            finalQuery.count = count;
        }
        return this.requestGet(this.route('medias.tags'), finalQuery);
    }

    getAuthors(query = {}, count = 10) {
        const finalQuery = {
            ...query,
        };
        if (count !== null) {
            finalQuery.count = count;
        }
        return this.requestGet(this.route('medias.authors'), finalQuery);
    }

    create(data) {
        return this.requestPost(this.route('medias.store'), data);
    }

    update(id, data) {
        return this.requestPut(
            this.route('medias.update', {
                media: id,
            }),
            data,
        );
    }

    replace(id, data) {
        return this.requestPost(
            this.route('medias.replace', {
                media: id
            }),
            data
        )
    }

    requestDeleteMedia(id) {
        return this.requestPost(
            this.route('medias.requestDelete', {
                media: id,
            }),
        );
    }

    delete(id) {
        return this.requestDelete(
            this.route('medias.destroy', {
                media: id,
            }),
        );
    }

    forceDelete(id) {
        return this.requestDelete(
            this.route('medias.forceDestroy', {
                trashedMediaId: id
            })
        )
    }

    restore(id) {
        return this.requestPost(
            this.route('medias.restore', {
                trashedMediaId: id
            })
        )
    }

    createMediaJob(mediaId, mediaPipelineName) {
        return this.requestPost(
            this.route('medias.createJob', {
                media: mediaId
            }), {
                mediaPipelineName
            }
        )
    }

    restartMediaJob(mediaId, jobId) {
        return this.requestPost(
            this.route('medias.restartJob', {
                media: mediaId,
                jobId
            })
        )
    }
}

export default MediasApi;
